<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.keyword"
      clearable
      placeholder="请输入用户昵称"
    ></el-input>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.type"
      placeholder="反馈类型"
      clearable
      filterable
    >
      <el-option label="反馈类型" value=""></el-option>
      <el-option label="订单问题" value="1"></el-option>
      <el-option label="课程购买" value="2"></el-option>
      <el-option label="课程学习" value="3"></el-option>
      <el-option label="好物商城" value="4"></el-option>
      <el-option label="程序bug" value="5"></el-option>
      <el-option label="优化建议" value="6"></el-option>
      <el-option label="线下活动" value="7"></el-option>
      <el-option label="其他" value="8"></el-option>
    </el-select>

    <el-select
      class="search-el"
      size="mini"
      v-model="query.reply_status"
      placeholder="全部状态"
      clearable
      filterable
    >
      <el-option label="全部状态" value=""></el-option>
      <el-option label="已回复" value="1"></el-option>
      <el-option label="待回复" value="2"></el-option>
      <el-option label="已完结" value="3"></el-option>
    </el-select>

    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="user_id"
          label="用户ID"
          align="center"
          min-width="6%"
        ></el-table-column>

        <el-table-column
            prop="nickname"
            label="昵称"
            align="center"
            min-width="8%"
        ></el-table-column>

        <el-table-column
            prop="type_value"
            label="反馈类型"
            align="center"
            min-width="7%"
        ></el-table-column>

        <el-table-column
            prop="content"
            label="反馈内容"
            align="center"
            min-width="25%"
        ></el-table-column>

        <el-table-column label="图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div v-if="row.feedback_img != null">
              <el-button
                  type="success"
                  plain
                  @click="previewImg1(row.feedback_img)"
                  ref="btn"
                  size="mini"
              >
                预 览 + {{row.feedback_img.length}}
              </el-button>
            </div>
            <div v-else>暂无图片</div>
          </template>
        </el-table-column>

        <el-table-column
            prop="mobile"
            label="联系方式"
            align="center"
            min-width="9%"
        ></el-table-column>

        <el-table-column
            prop="created_at"
            label="反馈时间"
            align="center"
            min-width="7%"
        ></el-table-column>

        <el-table-column
            prop="reply_updated_at"
            label="修改时间"
            align="center"
            min-width="7%"
        ></el-table-column>

        <el-table-column
            prop="reply_status"
            label="状态"
            align="center"
            min-width="5%"
        ></el-table-column>

        <el-table-column
            prop="real_name"
            label="当前处理人"
            align="center"
            min-width="7%"
            v-if="feedbackChangeStatus == 1"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="setReply(row.id, row.user_id, row.type, row.reply_list, row.content, row.feedback_img)">【回复】</el-button>
            <span v-if="row.reply_status_value != 3">
              <el-button type="text" size="small" @click="setComplete(row.id, row.user_id, row.type)">【完结】</el-button>
            </span>
            <span v-if="row.feedback_change_status == 1 && row.reply_status_value != 3">
              <el-button type="text" size="small" @click="setAdminId(row.id, row.real_name)">【变更处理人】</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!-- 图片轮播 -->
    <el-dialog
        title="图片轮播"
        center
        :visible.sync="dialogImgs"
        width="60%"
        @close="closeDialogImgs"
    >
      <el-carousel :autoplay="false" style="height: 500px;">
        <el-carousel-item v-for="(item,index) in imgUrls" :src="item"  :key="index" style="height: 500px;">
          <div style="text-align: center;width: 100%;height: 100%;">
            <img :src="item" class="image-item" style="max-width: 100%;max-height: 100%;"/>
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

    <!-- 图片轮播1 -->
    <el-dialog
        title="图片轮播"
        center
        :visible.sync="dialogImgs1"
        width="60%"
        @close="closeDialogImgs1"
    >
      <el-carousel :autoplay="false" style="height: 500px;">
        <el-carousel-item v-for="(item,index) in imgUrls1" :src="item"  :key="index" style="height: 500px;">
          <div style="text-align: center;width: 100%;height: 100%;">
            <img :src="item" class="image-item" style="max-width: 100%;max-height: 100%;"/>
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>


    <el-dialog
        title="回复"
        :visible.sync="replyOrgVisible"
        :close-on-click-modal="true"
        :before-close="addReplyEditFormOnClose"
        width="65%"
    >
      <el-form :model="reply" label-width="100px" class="demo-ruleForm">
        <el-form-item label="反馈内容: " prop="feek_content" style="margin-bottom: auto;">
          <div>{{feek_content}}</div>
        </el-form-item>
        <el-form-item label="反馈图片: " style="margin-bottom: auto;">
          <div v-if="feek_img == null">暂无图片</div>
          <div v-else>
            <el-image
                v-for="(item, index) in feek_img"
                :key="index"
                style="width: 100px; height: 100px"
                :src="item"
                :preview-src-list="getPreviewImgList(index)"
            >
            </el-image>
          </div>
        </el-form-item>
        <el-form-item label="回复记录: " style="margin-bottom: auto;"></el-form-item>
        <div style="height:200px;width:95%;margin-left: 20px;overflow: auto;">
          <el-table
              border
              :data="relation.result.data"
              highlight-current-row
              v-loading="relation.listLoading1"
          >
            <el-table-column
                prop="name"
                label="角色"
                align="center"
                min-width="10%"
            ></el-table-column>

            <el-table-column
                prop="content"
                label="回复内容"
                align="center"
                min-width="50%"
            ></el-table-column>

            <el-table-column label="图片" align="center" min-width="20%">
              <template slot-scope="{ row }">
                <div v-if="row.feedback_img != null">
                  <el-button
                      type="success"
                      plain
                      @click="previewImg(row.feedback_img)"
                      ref="btn"
                      size="mini"
                  >
                    预 览 + {{row.feedback_img.length}}
                  </el-button>
                </div>
                <div v-else>暂无图片</div>
              </template>
            </el-table-column>

            <el-table-column
                prop="created_at"
                label="回复时间"
                align="center"
                min-width="20%"
            ></el-table-column>
          </el-table>
        </div>
        <el-form-item label="回复内容" prop="content" style="margin-top:10px">
          <el-input type="textarea" maxlength="400" v-model="reply.content" :rows="5" show-word-limit style="width: 95%;" @input="timeEffectInput"></el-input>
        </el-form-item>
        <el-form-item label="回复图片" prop="feedback_img">
          <el-upload class="uploader"  :action="ossAction"  :auto-upload="true"
                     :file-list="fileList" list-type="picture-card" :limit="limit?limit:3" :accept="fileType?fileType:'image/*'"
                     :before-upload="beforeImageUpload"  :multiple="true"
                     ref="fileupload" :on-exceed="handleUploadExceed" :on-remove="handleRemove" :http-request="uploadImagesOSSRequest"
                     :on-preview="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :append-to-body="true" :visible.sync="dialogImgVisible" style="z-index: 3000;text-align: center;"
                     :close-on-click-modal="false" :close-on-press-escape="false" custom-class="pub_dialog">
            <img width="80%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="setCancel()"
          >取 消</el-button
          >
          <el-button
              size="small"
              type="primary"
              @click="createReply()"
              :loading="updateLoading"
          >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
        title="变更处理人"
        :visible.sync="changeAdminOrgVisible"
        :close-on-click-modal="true"
        :before-close="addChangeAdminEditFormOnClose"
        width="40%"
    >
      <el-form :model="change_admin_id" label-width="100px" class="demo-ruleForm">
        <el-form-item label="当前处理人: " prop="current_real_name" style="margin-bottom: auto;">
          <div>{{current_real_name}}</div>
        </el-form-item>

        <el-form-item label="变更为" prop="change_real_name" style="margin-top:10px">
          <el-cascader
              v-model="change_admin_id.value"
              :options="change_real_name"
              :props="{ expandTrigger: 'hover' }"
              style="width: 360px"
              @change="handleChange"></el-cascader>
        </el-form-item>

        <el-form-item style="text-align: right">
            <el-button size="small" @click="changeAdminCancel()">取 消</el-button>
            <el-button size="small" type="primary" @click="changeAdmin()" :loading="updateLoading">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {getFeedbackList, feedbackStore, feedbackComplete, setFeedbackAdminId} from "@/api/problemFeedback";
import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 3
    },
    fileType: String,
  },
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      feedbackChangeStatus: 0,
      loading: false,
      total: 0,
      query: {
        keyword: "",
        type: "",
        reply_status: '2',
        page: 1,
        limit: 20,
      },

      sid: 0,

      relation: {
        listLoading1: false,
        result: {
          data: [],
        },
      },
      reply: {
        id: 0,
        user_id: 0,
        type: 0,
        content: "",
        feedback_img:[]
      },

      change_admin_id: {
        id: 0,
        value: 0
      },

      // 图片轮播
      dialogImgs: false,
      imgUrls: [],
      dialogImgs1: false,
      imgUrls1: [],
      isshow: false,
      ossAction: "",
      ossData: {},
      aliyunOssToken: "",
      updateLoading: false,
      fileList:[],
      dialogImageUrl: "",
      dialogImgVisible: false,
      disabled: false,
      images:[],
      num:0,
      fileNum:0,
      replyOrgVisible: false,
      feek_content: '',
      feek_img: [],
      changeAdminOrgVisible: false,
      current_real_name: '',
      change_real_name: [],
    };
  },
  created: function () {
    this.getList();
  },
  methods: {

    setReply(id, user_id, type, reply_list, content, feedback_img){
      console.log(this.feek_img.length)
      this.feek_content = content
      this.feek_img = feedback_img
      this.relation.result.data = reply_list;
      this.relation.listLoading1 = false;
      console.log(this.fileList)
      this.replyOrgVisible = true;
      this.reply.id = id;
      this.reply.user_id = user_id;
      this.reply.type = type;
    },

    addReplyEditFormOnClose() {
      this.replyOrgVisible = false;
      this.getList()
    },

    setCancel() {
      this.replyOrgVisible = false;
      this.getList()
    },

    tempReset() {
      this.feek_content = ''
      this.feek_img = []
      this.fileList = []
      this.feedbackChangeStatus = 0
      this.change_real_name = [];
      this.reply = {
        id: 0,
        user_id: 0,
        type: 0,
        content: "",
        feedback_img: [],
      };
      this.change_admin_id = {
        id: 0,
        value: 0
      };
    },

    getPreviewImgList: function (index) {
      let arr = []
      for (let i = 0; i < this.feek_img.length; i++) {
        arr.push(this.feek_img[i + index])
        if (i + index >= this.feek_img.length - 1) {
          // 为了取后边小值(买用绝对值)
          index = 0 - (i + 1)
          return arr
        }
      }
    },

    // 图片
    previewImg1(imgs) {
      this.imgUrls1 = imgs;
      this.dialogImgs1 = true;
    },
    closeDialogImgs1() {
      this.imgUrls1 = [];
    },


    timeEffectInput(value) {
      //value 为获取到的输入框的值
      if (value.length >= 400) {
        this.$el.querySelector('.el-input__count').style = 'color:red !important'
      } else {
        this.$el.querySelector('.el-input__count').style = 'color:#909399 !important'
      }
    },
    getList() {
      this.tempReset();
      this.loading = true;
      getFeedbackList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.feedbackChangeStatus = response.data.feedbackChangeStatus;
        console.log(response.data.departments)
        if (response.data.departments != '') {
            this.change_real_name = JSON.parse(response.data.departments);
        }
        this.loading = false;
      });
    },

    setComplete(id, user_id, type) {
      this.is_delete = 1
      this.$confirm("是否将该反馈变更为完结状态？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        feedbackComplete({
          id: id,
          user_id: user_id,
          type: type,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    setAdminId(id, real_name){
      this.changeAdminOrgVisible = true;
      this.change_admin_id.id = id;
      this.current_real_name = real_name;
    },

    handleChange(value) {
      this.change_admin_id.value = value[1]
    },

    addChangeAdminEditFormOnClose() {
      this.changeAdminOrgVisible = false;
      this.getList()
    },

    changeAdminCancel() {
      this.changeAdminOrgVisible = false;
      this.getList()
    },

    changeAdmin() {
      if (this.change_admin_id.value == 0) {
        this.$message({
          message: '请选择处理人',
          type: "error",
        });
        return false
      }
      this.updateLoading = true;
      setFeedbackAdminId(this.change_admin_id)
          .then((response) => {
            this.updateLoading = false;
            if (response.status == 2000) {
              this.changeAdminOrgVisible = false
              this.$message.success(response.message);
              this.getList();
              this.dialogVisible = false;
            }
          })
          .catch((err) => {
            this.updateLoading = false;
          });
    },

    // 图片
    previewImg(imgs) {
      this.imgUrls = imgs;
      this.dialogImgs = true;
    },
    closeDialogImgs() {
      this.imgUrls = [];
    },

    beforeImageUpload(file) {
      console.log(222, file)
      let types = ['image/jpeg', 'image/gif', 'image/jpg', 'image/png'];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 1;
      if (!isImage) {
        this.$message.error('只能上传 jpg、jpeg、png、gif 格式!')
        return false
      }
      if (!isLtSize) {
        this.$message.error('上传图片大小不能超过 1MB!');
        return false;
      }
      beforeImageUpload(file);
    },
    handlebeforeUpload(file) {
      // 这里做可以做文件校验操作
      const isImg = /^image\/\w+$/i.test(file.type)
      console.log(file,isImg,this.fileType)
      if (!isImg && this.fileType == 'image/*') {
        this.$message.error('只能上传 JPG、PNG、GIF 格式!')
        return false
      }
      this.fileNum++;
    },
    handleUploadExceed() {
      this.$message.error(`最多上传${this.limit}张图片`)
    },
    handleRemove: function(file, fileList) {
      // fileList 为删除后的文件列表
      const value = fileList.map(v => v.url)
      this.reply.feedback_img = value;
      this.$emit('input', value)
    },
    //多图上传方法
    uploadImagesOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          let imageUrl = fileUrl;
          this.reply.feedback_img.push(imageUrl);
          this.num++;
          if(this.num == this.fileNum){
            this.num = 0;
            this.fileNum = 0;
            // 这里如果 this.value.push(imageUrl) 这么写，vue会报出警告，大概意思是value作为props不应该在子组件中被修改
            // 应该根据 value 得到新的值，而不能修改它，this.value.concat(imageUrl)也是可以的，concat方法返回新的数组
            // this.$emit('input', [...this.value, imageUrl])
            this.$emit('input', this.value.concat(this.reply.feedback_img))
            this.reply.feedback_img =[];
          }
        });
      });
    },
    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgVisible = true;
    },

    createReply() {
      console.log(this.reply.feedback_img)
      if (this.reply.content == '' && this.reply.feedback_img.length == 0) {
        this.$message({
          message: '您未填写内容',
          type: "error",
        });
        return false
      }
      this.updateLoading = true;
      console.log(this.reply)
      feedbackStore(this.reply)
          .then((response) => {
            this.updateLoading = false;
            if (response.status == 2000) {
              this.replyOrgVisible = false
              this.$message.success(response.message);
              this.getList();
              this.dialogVisible = false;
            }
          })
          .catch((err) => {
            this.updateLoading = false;
          });
    },
  },
  mounted() {},
};
</script>
<style>
.el-cascader-menu__wrap {
  height: 400px;
}
</style>
